import axios from 'axios';

export const keystorePut = async (payload: string) => {
    const { data } = await axios.post('/api/v1/zendeskchat/payloads', payload);
    return data?.id
};
